<template>
  <div class="risk-selection-slider" data-testid="risk-selection-slider">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="risk-selection-slider__button-container"
    >
      <button
        data-testid="slider-button"
        :class="{
          'risk-selection-slider__button': true,
          'risk-selection-slider__button--active': currentIndex === index + 1
        }"
        @click="setCurrentIndex(index + 1)"
      >
        {{ index + 1 }}
      </button>
      <div
        v-if="recommendedRisk === index + 1"
        class="risk-selection-slider__recommended-container"
      >
        <BaseIcon icon="EA0200" />
        <div
          id="recommended-texts"
          class="risk-selection-slider__recommended-texts"
        >
          <BaseText size="p6" :color="recomendedTitleColor">
            Recomendado
          </BaseText>
          <BaseText size="p6" :color="recomendedDescriptionColor">
            Dentro do seu perfil
          </BaseText>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue';

import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface EmitEvents {
  (event: 'change', index: number): void;
}
const emit = defineEmits<EmitEvents>();

interface Props {
  options: number;
  recommendedRisk: number;
  maxWidth: number;
}
const props = defineProps<Props>();

const currentIndex = ref(props.recommendedRisk);

const setCurrentIndex = (index: number) => {
  currentIndex.value = index;

  emit('change', index);
};

const recomendedTitleColor = computed(() => {
  return currentIndex.value === props.recommendedRisk
    ? NebraskaColors.elementPrimary
    : NebraskaColors.elementSecondary;
});

const recomendedDescriptionColor = computed(() => {
  return currentIndex.value === props.recommendedRisk
    ? NebraskaColors.elementSecondary
    : NebraskaColors.elementDisabled;
});

onMounted(() => {
  const widhtScreen = window.screen.width;

  if (widhtScreen < props.maxWidth) {
    if (props.recommendedRisk === 1) {
      const recommended = window.document.getElementById('recommended-texts');

      recommended!.style.left = '50px';
      recommended!.style.textAlign = 'left';
    }

    if (props.recommendedRisk === props.options) {
      const recommended = window.document.getElementById('recommended-texts');

      recommended!.style.right = '50px';
      recommended!.style.textAlign = 'right';
    }
  }
});
</script>

<style lang="less" scoped>
.risk-selection-slider {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: linear-gradient(
    to right,
    rgba(65, 134, 77, 1),
    rgba(211, 148, 78, 1),
    rgba(178, 59, 81, 1)
  );
  border-radius: @size-radius-max;

  &__button-container {
    position: relative;
    display: flex;
    justify-content: center;
  }

  &__button {
    width: 48px;
    height: 48px;
    color: @element-over-image;
    background-color: rgba(250, 248, 248, 0.15);
    border-radius: @size-radius-max;

    &--active {
      background-color: @static-black;
    }
  }

  &__recommended-container {
    width: 120px;
    position: absolute;
    top: 64px;
    text-align: center;
  }

  &__recommended-texts {
    width: 120px;
    position: relative;
  }
}
</style>
